import React, { useCallback, useMemo } from 'react';

import { CommonTableProps } from '@/types/message';

import { Table } from 'antd';
import './index.less';
import usePage from '@/hooks/usePage';
const prefix = 'common-table';
const CommonTable: React.FC<CommonTableProps> = (props) => {
    const {paginationConfig,onClick=()=>void 0,rowSelection={},showSelectText=false,tableConfig,pageChange}=props;
     /**
       * 已选多少项
       */
      const selectListText=useMemo(() =>{
        return <div className='message-view-select-list-text'>{`已选 ${tableConfig?.rowSelection?.selectedRowKeys?.length} 项，共 ${tableConfig?.dataSource?.length} 项`}</div>
      },[tableConfig?.rowSelection?.selectedRowKeys,tableConfig?.dataSource])
    /**
     * 分页改变事件
     */
    const onCurrentPageChange=useCallback((current:any,pageSize:any) => {
      pageChange && pageChange(current,pageSize)
    } ,[paginationConfig])
    const pagination = props.pagination ===false?false: {
      current:paginationConfig?.currentPage,
      pageSize:paginationConfig?.pageSize,
      onChange: onCurrentPageChange,
      showSizeChanger: false,
      total: paginationConfig?.total,
      showTotal:showSelectText? (total:any) => selectListText :null,
      ...props.pagination
    }
  return (
    <div onClick={onClick}>
      <Table {...props.tableConfig} 
      
          className={'common-table '+props?.className }
          pagination={pagination}
    
      />
    </div>
  );
};

export default React.memo(CommonTable);
